// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gc-point[data-v-92432a82]{text-align:center;line-height:26px;font-size:1rem}.gc-point .point-plus[data-v-92432a82]{display:inline-block;color:#286549;background-color:#8febb6;border-radius:13px 0 0 13px}.gc-point .point-minus[data-v-92432a82]{display:inline-block;background-color:#ffb6c2;color:#cc1432;border-radius:0 13px 13px 0}.gc-point .onlyOne[data-v-92432a82]{border-radius:13px}", ""]);
// Exports
module.exports = exports;
